import styles from "./ImageDetail.module.css";
// import transaction from "../../images/transaction.svg";
// import cart from "../../images/cart.svg";
import TimeAgo from "javascript-time-ago";
import ReactTimeAgo from "react-time-ago";
import en from "javascript-time-ago/locale/en.json";
TimeAgo.addDefaultLocale(en);

const TrandingBottomSection = ({ apiData }) => {
  return (
    <div className="container-fluid p-0">
      <div className="row">
        <div className="col-12">
          {apiData.length > 0 ? (
            <table className={`${styles.CustomTable} table table-dark m-0`}>
              <thead>
                <tr>
                  <th>Price</th>
                  <th>From</th>
                  <th>To</th>
                  <th className="text-end">Time</th>
                </tr>
              </thead>
              <tbody>
                {apiData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.gas}</td>
                    <td>{item.from}</td>
                    <td>{item.to}</td>
                    <td className="text-end">
                      {/* {new Date(item.timeStamp * 1000)
                        .toISOString()
                        .substr(14, 5)} */}
                        <ReactTimeAgo date={new Date(item.timeStamp * 1000)} locale="en-US"/>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="text-center py-4">
              <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrandingBottomSection;
